import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../../_metronic/helpers'
import AddNotesModel from './modal/AddNotesModel'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {DeleteUserNotes, GetUserNotes, getUserNotesList} from '../UserListSlice/UserListSlice'
import {
  CustomNumbersData,
  BusinessNameData,
  DedicatedNumbersData,
  ProfileDetailData,
  GetUserOnboarding,
  GetUserSubscriptions,
} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import InsertNewData from '../../../../Components/InsertNewData'
import moment from 'moment-timezone'
import {DedicatedNumberBadge} from '../../../../Utils/Constant/ArrayOfSideNav'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useLocation} from 'react-router-dom'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import SubscriptionTable from './Subscription'

type SubQuestion = {
  title: string
  answer?: {
    title: string
    answer: string | null
  }
}

type OnboardingItem = {
  title: string
  answer: string | string[]
  subQuestions: SubQuestion[]
}

const Overview = () => {
  const dispatch = useDispatch()

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  const userData = useSelector((state: any) => state?.ProfileData?.ProfileData)
  const ProfileDetailState = userProp ? userProp : userData

  const ProfileDetail = useSelector((state: any) => state?.ProfileData)

  const subscriptionsData = useSelector((state: any) => state?.ProfileData?.userSubscriptions)
  const [addNotes, setAddNotes] = useState<boolean>(false)
  const [selectedNote, setSelectedNote] = useState<any>({})
  const [deleteIds, setDeleteIds] = useState<string | null>(null)
  const [confirm, setConfirm] = useState<boolean>(false)

  const isAdmin = ['staffAdmin', 'superAdmin'].includes(GeneralDataOFLoginUser()?.role)

  const bgColor: any = {
    REQUESTED: 'warning',
    ACTIVE: 'success',
    DENIED: 'danger',
  }

  const bgColorCustom: any = {
    inactive: 'warning',
    active: 'success',
    DENIED: 'danger',
  }

  useEffect(() => {
    if (confirm === true) {
      dispatch(DeleteUserNotes(deleteIds)).then(() => {
        dispatch(ProfileDetailData(ProfileDetailState?.user?._id))
      })
      setConfirm(false)
      setDeleteIds(null)
    }
  }, [confirm, deleteIds, dispatch, ProfileDetailState?.user?._id])

  useEffect(() => {
    if (ProfileDetailState?.user?._id) {
      dispatch(DedicatedNumbersData(ProfileDetailState?.user?._id))
      dispatch(BusinessNameData(ProfileDetailState?.user?._id))
      dispatch(CustomNumbersData(ProfileDetailState?.user?._id))
      dispatch(GetUserOnboarding(ProfileDetailState?.user?._id))
      dispatch(GetUserSubscriptions(ProfileDetailState?.user?._id))
    }
  }, [ProfileDetailState, dispatch])

  const fetchUserDetailTotalMessage = () => {
    dispatch(ProfileDetailData(`${ProfileDetailState?.user?._id}?withTotal=true`))
  }

  const refetchSubscriptions = (page?: number, limit?: number) => {
    if (ProfileDetailState?.user?._id) {
      dispatch(
        GetUserSubscriptions({
          userId: ProfileDetailState?.user?._id,
          page,
          limit,
        })
      )
    }
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={!!deleteIds}
        stopClose={false}
        handleClose={() => setDeleteIds(null)}
        Message={'Are you sure, you want to delete Note?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [deleteIds]
  )

  const AddTagPopup = useMemo(
    () => (
      <AddNotesModel
        show={addNotes}
        handleClose={() => {
          setAddNotes(false)
          setSelectedNote({})
        }}
        selectedNote={selectedNote}
      />
    ),
    [addNotes, selectedNote]
  )

  const adminNotes = ProfileDetailState?.user?.notesDetails
    ? [...ProfileDetailState.user.notesDetails]
        .filter((note: any) => Object.keys(note).length > 0) // remove empty objects
        .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    : []

  const onboardingUserData = () => {
    if (Array.isArray(ProfileDetail.userOnboarding) && ProfileDetail.userOnboarding?.length) {
      const data = (ProfileDetail.userOnboarding as OnboardingItem[]).map((item) => {
        const answers = Array.isArray(item.answer) ? item.answer.join(', ') : item.answer

        const subAnswer = Array.isArray(item.subQuestions)
          ? item.subQuestions.map((sub) => ({
              title: sub.title,
              answer: sub.answer?.answer ?? '',
            }))
          : []

        return {
          title: item.title,
          answer: answers,
          sub: subAnswer,
        }
      })

      return data
    }

    return []
  }

  return (
    <>
      {confirmation}
      {AddTagPopup}
      <div className='card mb-6'>
        <div className='card-body'>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                      Account overview
                    </span>
                  </div>
                  <OverlayTrigger
                    placement='top'
                    overlay={
                      <Tooltip id='button-tooltip'>Click to get message details total</Tooltip>
                    }
                  >
                    <div
                      onClick={fetchUserDetailTotalMessage}
                      className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 text-center'
                    >
                      <span className='d-flex text-gray-400 text-hover-primary me-5 mb-2 '>
                        Activity of an time
                      </span>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr029.svg'
                        className='svg-icon-1x text-primary'
                      />
                    </div>
                  </OverlayTrigger>
                </div>
                <div className='d-flex my-4'>
                  <span className='btn btn-light-primary btn-sm me-2' id='kt_user_follow_button'>
                    <span className='svg-icon svg-icon-3 d-none'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                          fill='currentColor'
                        />
                        <path
                          d='M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                    <span className='indicator-label'>Manage account</span>
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2' />
                    </span>
                  </span>
                </div>
              </div>
              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1'>
                  <div className='d-flex flex-wrap justify-content-between gap-3'>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value='1378.73'
                          data-kt-countup-prefix='$'
                        >
                          $ {ProfileDetailState?.totalSpent?.toFixed(2)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Total spent</div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={480}
                        >
                          {ProfileDetailState?.totalSMS}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>SMS sent</div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={480}
                          data-kt-countup-prefix='%'
                        >
                          {ProfileDetailState?.totalMMS}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>MMS sent</div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={500}
                        >
                          {ProfileDetailState?.newSubscriber}
                        </div>
                        <span className='svg-icon svg-icon-3 ms-2 text-primary'>--</span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>New subscribers</div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={140}
                        >
                          0
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-danger ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Reviews</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card mb-6'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Notes</h3>
          </div>
          <div className='card-toolbar m-0 d-flex align-items-center'>
            <button
              type='button'
              className='btn btn-primary'
              style={{
                height: 'fit-content',
              }}
              onClick={() => setAddNotes(true)}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Add Note
            </button>
          </div>
        </div>
        <div className='card-body pt-2 pb-0'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0'>
                <thead>
                  <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200 border-bottom border-top'>
                    <th className='min-w-100px ps-4 fw-bolder'>Note</th>
                    <th className='min-w-100px ps-4'>Created At</th>
                    <th className='min-w-100px ps-4'>Created By</th>
                    <th className='min-w-100px   rounded-end fw-bolder text-end pe-10'>Actions</th>
                  </tr>
                </thead>
                <tbody className='p-5'>
                  {adminNotes.map((data: any, idx: number) => (
                    <tr key={idx}>
                      <td className='table-row-gray-200 border-bottom border-top ps-4'>
                        <p className='d-block mb-1 fs-6'>{data?.notes}</p>
                      </td>
                      <td>
                        {data?.createdAt ? moment(data?.createdAt).format('hh:mm DD/MM/YYYY') : '-'}
                      </td>
                      <td>{data?.createdByName}</td>
                      <td className='table-row-gray-200 border-bottom border-top pe-4'>
                        <div className='row'>
                          {/* <a
                            className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            onClick={() => {
                              setAddNotes(true)
                              setSelectedNote(data ?? null)
                            }}
                          >
                            <span className='svg-icon svg-icon-3'>
                              <i className='bi bi-pencil-fill'></i>
                            </span>
                          </a> */}
                          {isAdmin ? (
                            <button
                              type='button'
                              className='col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              onClick={() => setDeleteIds(data?._id ?? '1234')}
                            >
                              <span className='svg-icon svg-icon-3'>
                                <i className='bi bi-trash3-fill'></i>
                              </span>
                            </button>
                          ) : (
                            '-'
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className='abcd '>
                {/* <select onChange={(e: any) => setPage({...page, size: e.target.value,page:1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={purchase_history?.total}>ALL</option>
                </select> */}
                {/* <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={purchase_history?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Information */}
      <SubscriptionTable
        subscriptionsData={subscriptionsData}
        userId={ProfileDetailState?.user?._id || ''}
        onRefetch={refetchSubscriptions}
      />

      <div className={`card virtual-table mb-6`}>
        <div className='card-header pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1 small-title'>Dedicated Numbers</span>
          </h3>
        </div>
        {ProfileDetail?.dedicatedNumbers?.length > 0 ? (
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-100 align-middle gs-0 gy-6'>
                <thead>
                  <tr className='fw-400 text-dark text-muted '>
                    <th className=' rounded-start'>NUMBER</th>
                    <th className=''>TOTAL</th>
                    <th className=''>PLAN</th>
                    <th className=''>ACTIVATION</th>
                    <th className=''>Type</th>
                    <th className=''>EXPIRATION</th>
                    <th className=''>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {ProfileDetail?.dedicatedNumbers?.map((data: any, idx: number) => (
                    <tr key={idx} className=''>
                      <td className=''>
                        <a
                          //   href='#'
                          className='text-dark fw-bolder  d-block mb-1 fs-6'
                        >
                          {data?.audNumber}
                        </a>
                      </td>
                      <td>$ {+data?.totalAmount?.toFixed(2) || 0}</td>
                      <td>
                        <span>{data?.billingStatus?.toUpperCase()}</span>
                      </td>
                      <td>
                        {data?.activationTime !== null
                          ? moment(data?.activationTime)?.format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        <span
                          className={
                            data?.type === 'MMS'
                              ? 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                              : 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 w-50px py-5'
                          }
                        >
                          {data?.type}{' '}
                        </span>
                      </td>
                      <td>
                        {data?.expirationTime !== null
                          ? moment(data?.expirationTime).format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        <span
                          className={`badge badge-light- ${
                            DedicatedNumberBadge?.status?.[data?.status]
                          } green_text_badge badge-square p-4 w-50px py-5`}
                        >
                          {data?.status?.toUpperCase()}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <InsertNewData
            message={{
              title: 'No Dedicated Numbers setup (yet!)',
              subtitle: `It looks like you haven't purchased any dedicated numbers, get started to take full advantage of our inbox feature!`,
            }}
            isButtonShowing={false}
          />
        )}
      </div>

      <div className={`card mb-6`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1 small-title'>
              Custom Business Name (Alpha ID)
            </span>
            {/* <span className='text-muted mt-1 fw-bold fs-7'>Over 500 members</span> */}
          </h3>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        {ProfileDetail?.businessName?.length > 0 ? (
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-150px'>Business Name</th>
                    <th>REQUESTED</th>
                    <th>APPROVED</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {ProfileDetail?.businessName?.map((val: any, i: number) => (
                    <tr key={i}>
                      <td>{val?.businessname}</td>
                      <td>{moment(val?.requestedAt).fromNow()}</td>
                      <td>
                        {val?.approvedAt !== undefined ? moment(val?.approvedAt).fromNow() : '-'}
                      </td>
                      <td>
                        <span
                          className={`badge badge-light-${bgColor?.[val?.status]}`}
                          style={{textTransform: 'capitalize'}}
                        >
                          {val?.status}{' '}
                        </span>{' '}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
        ) : (
          <InsertNewData
            message={{
              title: 'No Business Name setup (yet!)',
              subtitle: `It looks like you haven't applied for a Business Name, get started to build more trust with your customers!`,
            }}
            isButtonShowing={false}
          />
        )}
        {/* begin::Body */}
      </div>

      <div className={`card mb-6`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1 small-title'>Custom number</span>
            {/* <span className='text-muted mt-1 fw-bold fs-7'>Over 500 members</span> */}
          </h3>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        {ProfileDetail?.customNumbers?.length > 0 ? (
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-150px'>NAME</th>
                    <th>NUMBER</th>
                    <th>REQUESTED</th>
                    <th>APPROVED</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {ProfileDetail?.customNumbers?.map((val: any, i: number) => (
                    <tr key={i}>
                      <td>{val?.name}</td>
                      <td>{val?.number}</td>
                      <td>{moment(val?.createdAt).fromNow()}</td>
                      <td>
                        {val?.approvedAt !== undefined ? moment(val?.approvedAt).fromNow() : '-'}
                      </td>
                      <td>
                        <span
                          className={`badge badge-light-${bgColorCustom?.[val?.status]}`}
                          style={{textTransform: 'capitalize'}}
                        >
                          {val?.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
        ) : (
          <InsertNewData
            message={{
              title: 'No Custom Number verified (yet!)',
              subtitle: `It looks like you haven't verified any numbers yet - this will allow you to easily use your own number to send messages`,
            }}
            isButtonShowing={false}
          />
        )}
        {/* begin::Body */}
      </div>

      <div className='card mb-6'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Preferences</h3>
          </div>
        </div>
        <div className='card-body pt-2 pb-0'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0'>
                <thead>
                  <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200 border-bottom border-top'>
                    <th className='min-w-400px ps-4 fw-bolder'>Onboarding</th>
                    <th className='rounded-end fw-bolder  pe-10'>Response</th>
                  </tr>
                </thead>
                <tbody className='p-5'>
                  {onboardingUserData()?.map((data: any, idx: number) => (
                    <>
                      <tr key={idx}>
                        <td
                          className={`table-row-gray-200 ${
                            data?.sub?.length === 0 ? 'border-bottom' : ''
                          } border-top ps-4`}
                        >
                          <p className='d-block mb-1 fs-6'>{data?.title}</p>
                        </td>
                        <td
                          className={`table-row-gray-200 ${
                            data?.sub?.length === 0 ? 'border-bottom' : ''
                          } border-top ps-4`}
                        >
                          <p className='d-block mb-1 fs-6'>{data?.answer}</p>
                        </td>
                      </tr>
                      {data?.sub?.length > 0 ? (
                        <>
                          {data?.sub?.map((item: any, subIdx: number) => (
                            <tr key={subIdx}>
                              <td className='table-row-gray-200 ps-4'>
                                <span className='d-block mb-1 fs-6'>- {item?.title}</span>
                              </td>
                              <td className='ps-4'>
                                <span className='d-block mb-1 fs-6'>{item?.answer}</span>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : null}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className='card'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Activity</h3>
          </div>
          <div className='card-toolbar m-0'>
            <ul
              className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0 fw-bolder mt-5'
              role='tablist'
            >
              <li className='nav-item' role='presentation'>
                <a
                  id='kt_activity_today_tab'
                  className='nav-link justify-content-center text-active-primary fw-lighter active h-40px'
                  data-bs-toggle='tab'
                  role='tab'
                  href='#kt_activity_today'
                >
                  This week
                </a>
              </li>
              <li className='nav-item' role='presentation'>
                <a
                  id='kt_activity_week_tab'
                  className='nav-link justify-content-center text-active-gray-800 fw-lighter h-40px'
                  data-bs-toggle='tab'
                  role='tab'
                  href='#kt_activity_week'
                >
                  Last month
                </a>
              </li>
              <li className='nav-item' role='presentation'>
                <a
                  id='kt_activity_month_tab'
                  className='nav-link justify-content-center text-active-gray-800 fw-lighter h-40px'
                  data-bs-toggle='tab'
                  role='tab'
                  href='#kt_activity_month'
                >
                  All
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/*end::Card head*/}
        {/*begin::Card body*/}
        <div className='card-body'>
          {/*begin::Tab Content*/}
          <div className='tab-content'>
            <div
              id='kt_activity_today'
              className='card-body p-0 tab-pane fade show active'
              role='tabpanel'
              aria-labelledby='kt_activity_today_tab'
            >
              <div className='timeline'>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px me-4'>
                    <div className='symbol-label bg-light-info'>
                      <span className='svg-icon svg-icon-2 text-info'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                        >
                          <path
                            d='M2 4V16C2 16.6 2.4 17 3 17H13L16.6 20.6C17.1 21.1 18 20.8 18 20V17H21C21.6 17 22 16.6 22 16V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4Z'
                            fill='currentColor'
                          />
                          <path
                            opacity='0.3'
                            className='text-white'
                            d='M18 9H6C5.4 9 5 8.6 5 8C5 7.4 5.4 7 6 7H18C18.6 7 19 7.4 19 8C19 8.6 18.6 9 18 9ZM16 12C16 11.4 15.6 11 15 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H15C15.6 13 16 12.6 16 12Z'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-10 mt-n1'>
                    <div className='text-center'>
                      <span className='badge badge-light-primary fw-bolder mb-4 px-4 py-2 rounded-4 mx-auto d-inline-flex'>
                        Today
                      </span>
                    </div>
                    <div className='pe-3 mb-5'>
                      <div className='fs-5 fw-bold mb-2'>Scheduled a campaign to be sent</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          sent on Monday, June 13,2022 at 4:30pm
                        </div>
                      </div>
                    </div>
                    <div className='overflow-auto pb-5'>
                      <div className='align-items-center border-gray-300 d-flex mb-5 py-3 rounded gap-10'>
                        <span className='fs-5 text-dark text-hover-primary fw-bold'>
                          VIP Father's day
                        </span>
                        <div className='min-w-175px pe-2 text-center'>
                          <span className='badge badge-light-success'>MMS</span>
                        </div>
                        <div className='text-gray-600'>1,300 recipients</div>
                        <div className='text-gray-600'>2,600 credits</div>
                        <span className='btn btn-sm btn-light btn-active-light-primary'>View</span>
                      </div>
                      <div className='text-center'>
                        <span className='badge badge-light-primary fw-bolder px-4 py-2 rounded-4 mx-auto d-inline-flex'>
                          June 13, 2022
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px'>
                    <div className='symbol-label bg-light'>
                      <span className='svg-icon svg-icon-2 text-primary'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                        >
                          <path
                            d='M2 4V16C2 16.6 2.4 17 3 17H13L16.6 20.6C17.1 21.1 18 20.8 18 20V17H21C21.6 17 22 16.6 22 16V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4Z'
                            fill='currentColor'
                          />
                          <path
                            opacity='0.3'
                            className='text-white'
                            d='M18 9H6C5.4 9 5 8.6 5 8C5 7.4 5.4 7 6 7H18C18.6 7 19 7.4 19 8C19 8.6 18.6 9 18 9ZM16 12C16 11.4 15.6 11 15 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H15C15.6 13 16 12.6 16 12Z'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-15 mt-n2'>
                    <div className='overflow-auto pe-3'>
                      <div className='fs-5 fw-bold mb-2'>Sent quick message</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          Sent on Monday, June 13,2022 at 4:13pm
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px'>
                    <div className='symbol-label bg-light-warning'>
                      <span className='svg-icon svg-icon-2 svg-icon-gray-500'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          xmlnsXlink='http://www.w3.org/1999/xlink'
                          width='24px'
                          height='24px'
                          viewBox='0 0 24 24'
                          version='1.1'
                        >
                          <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                            <rect x={0} y={0} width={24} height={24} />
                            <path
                              d='M18,2 L20,2 C21.6568542,2 23,3.34314575 23,5 L23,19 C23,20.6568542 21.6568542,22 20,22 L18,22 L18,2 Z'
                              fill='#ffc700'
                              opacity='0.3'
                            />
                            <path
                              d='M5,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,19 C20,20.6568542 18.6568542,22 17,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z'
                              fill='#ffc700'
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-15 mt-n1'>
                    <div className='pe-3 mb-5'>
                      <div className='fs-5 fw-bold mb-2'>Added 1,300 new people to "Main List"</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          Added on Monday, June 13,2022 at 4:20pm
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px'>
                    <div className='symbol-label bg-light-success'>
                      <span className='svg-icon svg-icon-success svg-icon-2x'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          xmlnsXlink='http://www.w3.org/1999/xlink'
                          width='24px'
                          height='24px'
                          viewBox='0 0 24 24'
                          version='1.1'
                        >
                          <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                            <rect x={0} y={0} width={24} height={24} />
                            <path
                              d='M17.2718029,8.68536757 C16.8932864,8.28319382 16.9124644,7.65031935 17.3146382,7.27180288 C17.7168119,6.89328641 18.3496864,6.91246442 18.7282029,7.31463817 L22.7282029,11.5646382 C23.0906029,11.9496882 23.0906029,12.5503176 22.7282029,12.9353676 L18.7282029,17.1853676 C18.3496864,17.5875413 17.7168119,17.6067193 17.3146382,17.2282029 C16.9124644,16.8496864 16.8932864,16.2168119 17.2718029,15.8146382 L20.6267538,12.2500029 L17.2718029,8.68536757 Z M6.72819712,8.6853647 L3.37324625,12.25 L6.72819712,15.8146353 C7.10671359,16.2168091 7.08753558,16.8496835 6.68536183,17.2282 C6.28318808,17.6067165 5.65031361,17.5875384 5.27179713,17.1853647 L1.27179713,12.9353647 C0.909397125,12.5503147 0.909397125,11.9496853 1.27179713,11.5646353 L5.27179713,7.3146353 C5.65031361,6.91246155 6.28318808,6.89328354 6.68536183,7.27180001 C7.08753558,7.65031648 7.10671359,8.28319095 6.72819712,8.6853647 Z'
                              fill='#50cd89'
                              fillRule='nonzero'
                            />
                            <rect
                              fill='#50cd89'
                              opacity='0.3'
                              transform='translate(12.000000, 12.000000) rotate(-345.000000) translate(-12.000000, -12.000000)'
                              x={11}
                              y={4}
                              width={2}
                              height={16}
                              rx={1}
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-15 mt-n1'>
                    <div className='pe-3 mb-5'>
                      <div className='fs-5 fw-bold mb-2'>Set up connection with zapier</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          Added on Monday, June 13,2022 at 4:20pm
                        </div>
                      </div>
                    </div>
                    <div className='text-center'>
                      <span className='badge badge-light-primary fw-bolder px-4 py-2 rounded-4 mx-auto d-inline-flex'>
                        June 12, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px me-4'>
                    <div className='symbol-label bg-light-danger'>
                      <span className='svg-icon svg-icon-danger svg-icon-2x'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          xmlnsXlink='http://www.w3.org/1999/xlink'
                          width='24px'
                          height='24px'
                          viewBox='0 0 24 24'
                          version='1.1'
                        >
                          <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                            <polygon points='0 0 24 0 24 24 0 24' />
                            <path
                              d='M12,18 L7.91561963,20.1472858 C7.42677504,20.4042866 6.82214789,20.2163401 6.56514708,19.7274955 C6.46280801,19.5328351 6.42749334,19.309867 6.46467018,19.0931094 L7.24471742,14.545085 L3.94038429,11.3241562 C3.54490071,10.938655 3.5368084,10.3055417 3.92230962,9.91005817 C4.07581822,9.75257453 4.27696063,9.65008735 4.49459766,9.61846284 L9.06107374,8.95491503 L11.1032639,4.81698575 C11.3476862,4.32173209 11.9473121,4.11839309 12.4425657,4.36281539 C12.6397783,4.46014562 12.7994058,4.61977315 12.8967361,4.81698575 L14.9389263,8.95491503 L19.5054023,9.61846284 C20.0519472,9.69788046 20.4306287,10.2053233 20.351211,10.7518682 C20.3195865,10.9695052 20.2170993,11.1706476 20.0596157,11.3241562 L16.7552826,14.545085 L17.5353298,19.0931094 C17.6286908,19.6374458 17.263103,20.1544017 16.7187666,20.2477627 C16.5020089,20.2849396 16.2790408,20.2496249 16.0843804,20.1472858 L12,18 Z'
                              fill='#f1416c'
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-10 mt-n1'>
                    <div className='pe-3 mb-5'>
                      <div className='fs-5 fw-bold mb-2'>Sent a review request</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          sent on Monday, June 12,2022 at 4:30pm
                        </div>
                      </div>
                    </div>
                    <div className='overflow-auto pb-5'>
                      <div className='align-items-center border-gray-300 d-flex mb-5 py-3 rounded gap-10'>
                        <span className='fs-5 text-dark text-hover-primary fw-bold'>
                          VIP Father's day
                        </span>
                        <div className='min-w-175px pe-2 text-center'>
                          <span className='badge badge-light-success'>MMS</span>
                        </div>
                        <div className='text-gray-600'>1,300 recipients</div>
                        <div className='text-gray-600'>2,600 credits</div>
                        <span className='btn btn-sm btn-light btn-active-light-primary'>View</span>
                      </div>
                      <div className='text-center'>
                        <span className='badge badge-light-primary fw-bolder px-4 py-2 rounded-4 mx-auto d-inline-flex'>
                          June 12, 2022
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='timeline-item'>
                  <div className='timeline-line w-40px' />
                  <div className='timeline-icon symbol symbol-circle symbol-40px'>
                    <div className='symbol-label bg-light'>
                      <span className='svg-icon svg-icon-2 svg-icon-gray-500'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          xmlnsXlink='http://www.w3.org/1999/xlink'
                          width='24px'
                          height='24px'
                          viewBox='0 0 24 24'
                          version='1.1'
                        >
                          <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                            <rect x={0} y={0} width={24} height={24} />
                            <path
                              d='M18,2 L20,2 C21.6568542,2 23,3.34314575 23,5 L23,19 C23,20.6568542 21.6568542,22 20,22 L18,22 L18,2 Z'
                              fill='#ffc700'
                              opacity='0.3'
                            />
                            <path
                              d='M5,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,19 C20,20.6568542 18.6568542,22 17,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z'
                              fill='#ffc700'
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='timeline-content mb-5 mt-n2'>
                    <div className='overflow-auto pe-3'>
                      <div className='fs-5 fw-bold mb-2'>Added 1,300 new people to "Main List"</div>
                      <div className='d-flex align-items-center mt-1 fs-6'>
                        <div className='text-muted me-2 fs-7'>
                          Added on Monday, June 12,2022 at 4:13pm
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-flex flex-stack flex-wrap pt-10 justify-content-end'>
                  <ul className='pagination'>
                    <li className='page-item previous'>
                      <span className='page-link'>
                        <i className='previous' />
                      </span>
                    </li>
                    <li className='page-item active'>
                      <span className='page-link'>1</span>
                    </li>
                    <li className='page-item'>
                      <span className='page-link'>2</span>
                    </li>
                    <li className='page-item'>
                      <span className='page-link'>3</span>
                    </li>
                    <li className='page-item next'>
                      <span className='page-link'>
                        <i className='next' />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Overview
